import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Card } from 'react-bootstrap';
import { FaShieldAlt } from 'react-icons/fa';
import './PrivacyPolicy.css';
import BackToHome from '../components/BackToHome';

const PrivacyPolicy = () => {
  return (
    <Container className="py-5">
      <BackToHome />
      <Card>
        <Card.Header className="privacy-header">
          <h2 className="mb-0">
            <FaShieldAlt className="me-2" />
            Privacy Policy
          </h2>
        </Card.Header>
        <Card.Body className="privacy-body">
          {/* Title */}
          <div className="privacy-title">
            <h3>🔐 Privacy Policy</h3>
            <p className="intro-text">
              FarmX values your privacy. This Privacy Policy explains how we collect, use, and protect your information.
            </p>
          </div>

          {/* Section 1: Information We Collect */}
          <div className="privacy-section">
            <h4 className="section-title">1. Information We Collect</h4>
            <p className="subtitle">We may collect the following information:</p>
            <ul className="bullet-list">
              <li>Personal details (email address, phone number)</li>
              <li>Location data (only when you allow GPS access)</li>
              <li>Ad details (title, description, images, price)</li>
              <li>Chat messages (for user-to-user communication)</li>
              <li>Device and app usage data</li>
            </ul>
          </div>

          {/* Section 2: How We Use Your Information */}
          <div className="privacy-section">
            <h4 className="section-title">2. How We Use Your Information</h4>
            <p className="subtitle">We use your data to:</p>
            <ul className="bullet-list">
              <li>Display nearby ads based on your location</li>
              <li>Enable posting and managing ads</li>
              <li>Allow chat between buyers and sellers</li>
              <li>Improve app performance and user experience</li>
              <li>Prevent fraud and misuse</li>
            </ul>
          </div>

          {/* Section 3: Location Data */}
          <div className="privacy-section">
            <h4 className="section-title">3. Location Data</h4>
            <p className="subtitle">Location access is used only to:</p>
            <ul className="bullet-list">
              <li>Show nearby ads</li>
              <li>Improve search relevance</li>
            </ul>
            <p>
              You can disable location access at any time from your device settings.
            </p>
          </div>

          {/* Section 4: Data Storage & Security */}
          <div className="privacy-section">
            <h4 className="section-title">4. Data Storage & Security</h4>
            <ul className="bullet-list">
              <li>Images are securely stored using third-party cloud services</li>
              <li>User authentication is handled securely</li>
              <li>We take reasonable measures to protect your data</li>
            </ul>
          </div>

          {/* Section 5: Data Sharing */}
          <div className="privacy-section">
            <h4 className="section-title">5. Data Sharing</h4>
            <p>
              FarmX does not sell or rent your personal data. Data may be shared only:
            </p>
            <ul className="bullet-list">
              <li>When required by law</li>
              <li>To protect users and platform integrity</li>
            </ul>
          </div>

          {/* Section 6: User Control */}
          <div className="privacy-section">
            <h4 className="section-title">6. User Control</h4>
            <p className="subtitle">You may:</p>
            <ul className="bullet-list">
              <li>Edit or delete your ads</li>
              <li><Link to="/delete-account">Request account deletion</Link> – see how to delete your account and what data we remove</li>
              <li>Control location permissions</li>
            </ul>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PrivacyPolicy;
